module.exports = __webpack_public_path__ + "img/logo-en.379d43b1.svg";